import { apiClient, getActivePvzId } from './_shared.js'

// ============================================
// SCHEDULE & SHIFTS
// ============================================

export async function getSchedule(year, month) {
  const pvzId = getActivePvzId()
  if (!pvzId) return []
  const m = String(month).padStart(2, '0')
  const startDate = `${year}-${m}-01`
  const endDate = `${year}-${m}-${new Date(year, month, 0).getDate()}`
  return await apiClient(`/schedule?pvzId=${pvzId}&startDate=${startDate}&endDate=${endDate}`)
}

export async function upsertScheduleDay(employeeId, workDate, hours, linkedTo = null, shiftRole = 'employee', startedAt = null, endedAt = null, isAdmin = true, pvzIdParam = null) {
  const pvzId = pvzIdParam || getActivePvzId()
  return await apiClient('/schedule/upsert', {
    method: 'POST',
    body: JSON.stringify({ pvz_id: pvzId, employee_id: employeeId, work_date: workDate, hours, linked_to: linkedTo, shift_role: shiftRole, started_at: startedAt, ended_at: endedAt, is_planned: false, hours_source: isAdmin ? 'owner_manual' : 'employee_manual', approval_status: isAdmin ? 'approved' : 'pending' })
  })
}

export async function upsertSchedulePlanned(employeeId, workDate, shiftRole, pvzIdParam = null) {
  const pvzId = pvzIdParam || getActivePvzId()
  return await apiClient('/schedule/planned', {
    method: 'POST',
    body: JSON.stringify({ pvz_id: pvzId, employee_id: employeeId, work_date: workDate, shift_role: shiftRole })
  })
}

export async function deleteScheduleDay(employeeId, workDate) {
  return await apiClient(`/schedule/${employeeId}/${workDate}`, { method: 'DELETE' })
}

export async function getActiveShift(employeeId) {
  const pvzId = getActivePvzId()
  return await apiClient(`/schedule/active-shift?pvzId=${pvzId}&employeeId=${employeeId}`)
}

export async function startShift(employeeId) {
  const pvzId = getActivePvzId()
  return await apiClient('/schedule/start-shift', {
    method: 'POST',
    body: JSON.stringify({ pvz_id: pvzId, employee_id: employeeId })
  })
}

export async function endShift(employeeId) {
  return await apiClient('/schedule/end-shift', {
    method: 'POST',
    body: JSON.stringify({ employee_id: employeeId })
  })
}

export async function startBreak(employeeId) {
  return await apiClient('/schedule/start-break', {
    method: 'POST',
    body: JSON.stringify({ employee_id: employeeId })
  })
}

export async function endBreak(employeeId) {
  return await apiClient('/schedule/end-break', {
    method: 'POST',
    body: JSON.stringify({ employee_id: employeeId })
  })
}

export async function getPendingScheduleRequests(pvzId) {
  return await apiClient(`/schedule/pending?pvzId=${pvzId}`)
}

export async function resolveScheduleRequest(employeeId, workDate, isApproved) {
  return await apiClient('/schedule/resolve', {
    method: 'POST',
    body: JSON.stringify({ employeeId, workDate, isApproved })
  })
}

export async function getScheduleAuditLogs(pvzId) {
  return await apiClient(`/schedule/audit-logs?pvzId=${pvzId}`)
}

export async function getPendingManualHours(pvzId) {
  return await apiClient(`/schedule/manual-hours?pvzId=${pvzId}`)
}

export async function getManualHours(isAdmin, employeeId, startDate, endDate) {
  const params = new URLSearchParams()
  if (isAdmin) params.append('isAdmin', 'true')
  if (employeeId) params.append('employeeId', employeeId)
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)
  return await apiClient('/schedule/manual-hours?' + params.toString())
}

export async function resolveManualHours(employeeId, workDate, isApproved) {
  return await apiClient('/schedule/resolve-manual', {
    method: 'POST',
    body: JSON.stringify({ employeeId, workDate, isApproved })
  })
}

export async function autoCloseExpiredShifts(pvzId) {
  // TODO: Implement backend endpoint for auto-closing shifts
  return
}

export async function getEarliestScheduleDate(pvzIdParam = null, employeeId = null) {
  try {
    const pvzId = pvzIdParam || getActivePvzId()
    if (!pvzId) return null
    const query = new URLSearchParams({ pvzId })
    if (employeeId) query.set('employeeId', employeeId)
    const res = await apiClient(`/schedule/earliest-activity?${query.toString()}`)
    return res?.earliestDate || null
  } catch {
    return null
  }
}
